import { z } from "zod";

export const FieldTypes = [
  "text",
  "email",
  "textarea",
  "number",
  "phonenumber",
  "checkbox",
  "select",
  "multiselect",
  "date",
  "time",
] as const;

export const FieldOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const FormFieldSchema = z.object({
  id: z.string(),
  referenceId: z.string().nullish(),
  referenceType: z.string().nullish(),
  name: z.string(),
  label: z.string(),
  type: z.enum(FieldTypes),
  placeholder: z.string().nullish(),
  selector: z.string().nullish(),
  required: z.boolean().default(false).nullish(),
  options: z.array(FieldOptionSchema).nullish(),
  defaultValue: z.any().nullish(),
});

export const DynamicFormSchema = z.object({
  id: z.string(),
  fields: z.array(FormFieldSchema),
});

export type FieldOption = z.infer<typeof FieldOptionSchema>;
export type DynamicFormField = z.infer<typeof FormFieldSchema>;
export type FormDefition = z.infer<typeof DynamicFormSchema>;
export type FieldType = (typeof FieldTypes)[number];
